import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children }) => {
    const isAuthenticated = useSelector((state) => state.accounts.storeged)

    if (!isAuthenticated) {
        return <Navigate to="/auth" replace />;
    }
    return children;
};

export default ProtectedRoute;
